<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-6">
        <i class="far fa-copyright"></i> {{ currentYear }} {{ brand.brandName }}. All Rights Reserved.
      </div>
    </div>
  </div>
</div>
